import axios from 'axios'
import config from '../config/app'
import Helper from '../helper/helper'

const bannersAPI = {
  get (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/v2/banner?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  create (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'post',
        url: config.server + '/v2/banner/add',
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  update (data, id) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'post',
        url: config.server + '/v2/banner/edit/' + id,
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  delete (id) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/v2/banner/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCurrentActiveBanner (type) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/v2/banner/active-banner/' + type).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}
export default bannersAPI



// WEBPACK FOOTER //
// ./src/api/banners.js